import React from 'react';
import { IonButton, IonModal } from '@ionic/react';
import QList from './QList';
import { useUIStore } from '../stateManagement/UIZustand';
import { useURLStore } from '../stateManagement/URLZustand';
import { _dict } from '../constants';
import { useGlobalStore } from '../stateManagement/globalZustand';

interface QModalProps {
    isOpen: boolean;
    onClose: () => void;
}

const QModal: React.FC<QModalProps> = ({ isOpen, onClose }) => {
    const { visibleLabels, getURLTo, getParentNode, URLVars } = useURLStore();
    const { lang } = useGlobalStore();

    let items = [];
    let itemAutoQuiz;
    let itemBigImage;
    let parentNode = getParentNode();
    
    // CHECKS
    // 1. AutoQuiz: If there are more than 3 visible labels, show the AutoQuiz option
    const itemAutoQuizCheck = visibleLabels && visibleLabels.length > 3;
    // 2. BigImage: If a parent label exists
    const itemBigImageCheck = parentNode !== null;


    itemAutoQuiz = {
        image: 'assets/q1.png',
        title: "#1",
        disabledNote: _dict.autoQuizTooFewCards[lang],
        goToUrl: getURLTo().autoquiz(),
        description: _dict.autoQuizDescription[lang],
        disabled: !itemAutoQuizCheck
    };

    itemBigImage = {
        image: 'assets/q2.png',
        title: "#2",
        disabledNote: _dict.bigImageQuizAlert[lang],
        goToUrl: parentNode ? getURLTo().task(1,parentNode, URLVars.nodePath! ) : '',
        description: _dict.bigImageDescription[lang],
        disabled: !itemBigImageCheck
    };

    items.push(itemAutoQuiz);
    items.push(itemBigImage);


    
    return (
        <IonModal isOpen={isOpen} onDidDismiss={onClose} >
            <QList items={items} />
            <IonButton color="danger" onClick={onClose}>{_dict.close[lang]}</IonButton>
        </IonModal>
    );
};

export default QModal;